var React = require('react');

function VectorRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.7723 0.540231L17.8348 5.60273C17.9438 5.71172 18 5.85586 18 5.96836C18 6.08086 17.9451 6.25622 17.8352 6.36597L12.7727 11.4285C12.553 11.6482 12.1968 11.6482 11.9775 11.4285C11.7581 11.2087 11.7577 10.8526 11.9775 10.6332L16.0802 6.5305H0.5625C0.251578 6.5305 0 6.27893 0 5.99965C0 5.68872 0.251578 5.43715 0.5625 5.43715H16.0805L11.9777 1.33441C11.758 1.11468 11.758 0.758551 11.9777 0.539176C12.1975 0.319801 12.5543 0.320153 12.7723 0.540231Z","fill":"#005AAA"}));
}

VectorRight.defaultProps = {"width":"18","height":"12","viewBox":"0 0 18 12","fill":"none"};

module.exports = VectorRight;

VectorRight.default = VectorRight;
